<template>
    <div class="w-full mb-4 flex justify flex-col lg:flex-row">
        <label class="w-60 mr-6 lg:mt-4 lg:text-right mb-2 lg:mb-0 font-bold page-title flex lg:justify-end"
               :for="id">{{ $__(label) }}</label>

        <div class="flex flex-col w-full lg:w-3/5">
        <textarea :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
                  :class="['w-full rounded-md focus:border-l-4', error ? 'border-red-600 border-l-4' : 'border-gray-200']"
                  :placeholder="$__(placeholder)" :name="name" :id="id"
                  :cols="cols" :rows="rows"></textarea>
            <span v-if="error" class="text-sm font-bold ml-3 mt-2 text-red-600">{{ error }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'label',
        'id',
        'type',
        'name',
        'cols',
        'rows',
        'placeholder',
        'modelValue',
        'error'
    ],
    emits: ['update:modelValue']
}
</script>
